module.exports = __webpack_public_path__ + "img/img_6.76580be3.jpeg";